module.exports = __webpack_public_path__ + "img/tool-parallelogram-right.d4151474.svg";